'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _hdkSwitch = require('hdk-switch');

var _hdkSwitch2 = _interopRequireDefault(_hdkSwitch);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var RcButtonSwitch = _hdkSwitch2["default"].ButtonSwitch;
var ButtonSwitch = (_temp = _class = function (_React$Component) {
  _inherits(ButtonSwitch, _React$Component);

  function ButtonSwitch() {
    _classCallCheck(this, ButtonSwitch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ButtonSwitch.prototype.render = function render() {
    var _props = this.props;
    var prefixCls = _props.prefixCls;
    var iconType = _props.iconType;
    var className = _props.className;

    var cls = (0, _classnames2["default"])(_defineProperty({}, className, !!className));
    return _react2["default"].createElement(
      RcButtonSwitch,
      _extends({ className: cls }, this.props),
      _react2["default"].createElement(_icon2["default"], { type: iconType })
    );
  };

  return ButtonSwitch;
}(_react2["default"].Component), _class.defaultProps = {
  prefixCls: 'ant-button-switch'
}, _temp);
exports["default"] = ButtonSwitch;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/switch/ButtonSwitch.jsx
 ** module id = 233
 ** module chunks = 0
 **/